import script from "./experience-delete-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./experience-delete-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__